var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 .833l7.917 4.584v9.166L10 19.168l-7.917-4.584V5.418L10 .833zm0 1.926L3.75 6.378v7.245L10 17.24l6.25-3.618V6.378L10 2.759zm0 10.575a3.333 3.333 0 110-6.667 3.333 3.333 0 010 6.667zm0-1.667a1.667 1.667 0 100-3.334 1.667 1.667 0 000 3.334z",
    fill: "#58657C"
  })));
}
export default SvgSet;